import { render, staticRenderFns } from "./EventsComboBoxItem.vue?vue&type=template&id=c60b34f6&scoped=true&"
import script from "./EventsComboBoxItem.vue?vue&type=script&lang=ts&"
export * from "./EventsComboBoxItem.vue?vue&type=script&lang=ts&"
import style0 from "./EventsComboBoxItem.vue?vue&type=style&index=0&id=c60b34f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60b34f6",
  null
  
)

export default component.exports